import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FiGlobe } from "react-icons/fi";

const langNames = {
    en: "English",
    ka: "ქართული",
    es: "Español",
    de: "Deutsch",
};

export default function LanguageSwitcher() {
    const { i18n } = useTranslation();
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const handleClick = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", handleClick);
        return () => document.removeEventListener("mousedown", handleClick);
    }, []);

    const select = (lng) => {
        i18n.changeLanguage(lng);
        setOpen(false);
    };

    return (
        <div className="lang-dropdown" ref={ref}>
            <button className="lang-toggle" onClick={() => setOpen(!open)} aria-label="Change language">
                <FiGlobe size={18} />
                <span>{i18n.language.toUpperCase()}</span>
            </button>
            {open && (
                <div className="lang-menu">
                    {Object.entries(langNames).map(([code, name]) => (
                        <button
                            key={code}
                            className={`lang-menu-item ${i18n.language === code ? "active" : ""}`}
                            onClick={() => select(code)}
                        >
                            <span className="lang-code">{code.toUpperCase()}</span>
                            <span className="lang-name">{name}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
